import { defineNuxtPlugin, useHead, useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  if (!config.public.cookieyesId) {
    return
  }

  if (process.server) {
    nuxtApp.vueApp.runWithContext(() => {
      useHead({
        script: [
          {
            src: `https://cdn-cookieyes.com/client_data/${config.public.cookieyesId}/script.js`,
            type: 'text/javascript',
            async: true,
            id: 'cookieyes',
            tagPriority: -1,
          },
        ],
      })
    })
  }
})
